export default __webpack_public_path__ + "static/media/bsDollar.d5d3ce77.svg";